import { useTranslation } from "react-i18next";

import { Input, Text } from "@fragments";

import { pad2 } from "../../../hooks/dateUtils";

import "./styles.scss";

function dateToISO(d) {
    if (!d) return "";
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function isoToDate(iso) {
    if (!iso) return null;
    const [y, m, d] = iso.split("-");
    if (!y || !m || !d) return null;
    const year = parseInt(y, 10);
    const month = parseInt(m, 10);
    const day = parseInt(d, 10);
    if (!year || !month || !day) return null;
    const date = new Date(year, month - 1, day);
    if (
        date.getFullYear() !== year
        || date.getMonth() !== month - 1
        || date.getDate() !== day
    ) return null;
    return date;
}

function DateField({ label, date, onChange }) {
    const { t } = useTranslation("fragments");

    return (
        <label className="dpi-header-field">
            <Text.span contrast={5}>{label}</Text.span>
            <Input.Date
                value={dateToISO(date)}
                onInput={(iso) => {
                    const parsed = isoToDate(iso);
                    if (parsed) onChange(parsed);
                }}
                label=""
                placeholder={t("datePicker.datePlaceholder")}
            />
        </label>
    );
}

export default function HeaderInputs({ from, to, onFromChange, onToChange }) {
    const { t } = useTranslation("fragments");

    return (
        <div className="dpi-header">
            <DateField label={t("datePicker.startLabel")} date={from} onChange={onFromChange} />
            <DateField label={t("datePicker.endLabel")} date={to} onChange={onToChange} />
        </div>
    );
}
